import { tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools'; // import utility to set light and dark mode props

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tabsAnatomy.keys);

// define the base component styles
const baseStyle = definePartsStyle(props => {
  const { colorScheme: c } = props; // extract colorScheme from component props
  return {
    // define the part you're going to style
    tab: {
      fontWeight: 'semibold',
      _selected: {
        color: mode(`${c}.600`, `${c}.500`)(props),
        borderColor: mode(`${c}.600`, `${c}.500`)(props),
      },
    },
    tabpanel: {
      py: 'kilo',
    },
  };
});

// export the component theme
export const tabsTheme = defineMultiStyleConfig({
  baseStyle,
});
